module.exports = __webpack_public_path__ + "img/Icon.af393e67.png";